import { render, staticRenderFns } from "./CProductSelector.vue?vue&type=template&id=9242e312&scoped=true&"
import script from "./CProductSelector.vue?vue&type=script&lang=js&"
export * from "./CProductSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9242e312",
  null
  
)

export default component.exports